import { Component, Input, OnInit, ViewChild, Inject, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { ApsService } from "src/app/services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { StatesService, } from "src/app/services";
import { SpinnerService } from "../../../services/spinner.service";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog"
import { CrossFieldErrorMatcher } from "src/app/shared/helpers";
import { ErrorDialogComponent } from "src/app/components/error-dialog/error-dialog.component";
import { ProcessingDialogComponent } from "src/app/components/processing-dialog/processing-dialog.component";
import { APSMaster, UsState } from "src/app/models";
import { FormValidationService } from "src/app/services/form-validation.service";


@Component({
  selector: "app-edit-card-dialog",
  templateUrl: "./edit-card-dialog.component.html",
  styleUrls: ["./edit-card-dialog.component.scss"]
})
export class EditCardDialogComponent implements OnInit, OnDestroy
{
  card: APSMaster;
  isSubmitted: boolean = false;

  public form: FormGroup;

  public states: UsState[] = [];
  @Input() public showAddress: boolean = true;
  @Input() public showPrimary: boolean = true;
  @Input() public showSave: boolean = false;
  public showSpinner: boolean = false;
  public showCustHeader: boolean = false;

  public years: number[] = Array.from({ length: 10 }, (_, i) => (new Date()).getFullYear() + i);

  public errorMatcher = new CrossFieldErrorMatcher(["invalidMonth"]);
  private statesSubscription: Subscription;

  constructor(
    private fb: FormBuilder,
    private spinnerService: SpinnerService,
    private apsService: ApsService,
    private statesService: StatesService,
    private cdRef: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private formValidationService: FormValidationService,
    @Inject(MAT_DIALOG_DATA) public data: APSMaster,
  )
  {
    this.card = { ...data };

  }

  public ngOnInit(): void
  {
    this.statesSubscription = this.statesService.states.subscribe(s => this.states = s);

    this.form = this.fb.group({
      CoName: [this.data.CoName, []],
      NameFirst: [this.data.NameFirst, []],
      NameLast: [this.data.NameLast, []],
      Address1: [this.card.Address1, [Validators.required]],
      Address2: [this.card.Address2, []],
      City: [this.card.City, [Validators.required]],
      St: [this.card.St, [Validators.required]],
      Zip: [this.card.Zip, [Validators.required]],
      MaskedCardNo: [this.data.MaskedCardNo, []],
      CardNo: [this.data.CardNo, []],
      CardExprMonth: [this.card.CardExprMonth, [Validators.required]],
      CardExprYear: [this.card.CardExprYear, [Validators.required]],
      Primary: [this.card.Primary, []],
      CardType: [this.data.CardType, []],
      RecNo: [this.data.RecNo, []],
      SourceNo: [this.data.SourceNo],
      PymtMethod: [this.data.PymtMethod],
      ApplId: [this.data.ApplId],
      Appl: [this.data.Appl],
      BranchNo: [this.data.BranchNo],

    }, { validator: this.dateValidate.bind(this) });


  }
  ngAfterViewChecked()
  {
    this.cdRef.detectChanges();
  }
  public ngOnDestroy(): void
  {
    this.statesSubscription.unsubscribe();
  }

  public checkFormValidity(form: AbstractControl): void
  {
    form?.markAllAsTouched();

    if (this.formValidationService.checkFormValidity(form)) 
    {
      this.handleSubmit();
    }
  }
  
  public async handleSubmit(): Promise<void>
  {
    this.showCustHeader = false;
    this.isSubmitted = true;
    this.showSpinner = true;
    const dialogText: string = "Credit Card"
    const processingDialogRef = this.dialog.open(ProcessingDialogComponent, {
      data: dialogText,
      width: "400px",
      maxWidth: "90%",
      restoreFocus: false,
      disableClose: true,
    });

    const editCard = this.form.dirty ? JSON.parse(JSON.stringify(this.form.value)) : null;
    if (editCard) 
    {
      editCard.BranchNo = this.data.BranchNo;
      editCard.RefNo = this.data.RefNo;
      editCard.RefToken = this.data.RefToken;
      editCard.RefProfileId = this.data.RefProfileId;
      const result = await this.apsService.updatePaymentMethod(editCard)
      if (result)
      {
        this.dialog.closeAll();
        this.snackBar.open('✅ Your payment method was edited successfully', 'Close', {
          duration: 3000,
          panelClass: ['success-snackbar'],
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
      else
      {

        this.errorDialog("");
        processingDialogRef.close();
      }
    }
    else
    {
      this.dialog.closeAll();
    }
    this.showSpinner = false;
  }

  errorDialog(error): void
  {
    this.isSubmitted = false;
    const errorMessage: string = "An error occurred while saving your payment method. \n" + error;

    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      minWidth: "360px",
      data: errorMessage,
    });

    dialogRef.afterClosed().subscribe(_ =>
    {
      this.isSubmitted = false;
      this.showCustHeader = true;
    });
    this.spinnerService.hide();
  }

  private dateValidate(fg: FormGroup): ValidationErrors | null
  {

    const expYear = parseInt(fg.get("CardExprYear").value);
    const expMonth = parseInt(fg.get("CardExprMonth").value, 10);
    const currentDate = new Date();

    if (expYear > 999)
    {
      if (expMonth < 1 || expMonth > 12)
      {
        return { invalidMonth: true }
      }
      if (expYear < currentDate.getFullYear())
      {
        return { invalidMonth: true }
      }
      if (expYear <= currentDate.getFullYear() && expMonth < (currentDate.getMonth() + 1))
      {
        return { invalidMonth: true };
      }
    }
    return null;
  }

}